module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"revisedDocumentInfo":"Tamamlanan Döküman Bilgisi","urgentActionText":"Acil Alınacak Aksiyonlar","reasonAnalysisText":"Kök Neden Analizi","additionalFiles":"Ek Dosyalar","action":"Genel Aksiyon Tanımları"},"en":{"revisedDocumentInfo":"Complited Document Information","urgentActionText":"Urgent Actions to be taken","reasonAnalysisText":"Root Cause Analysis","auditDate":"Audit Date","additionalFiles":"Additional Files","action":"Action"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/TicketDetailCard.vue
// module id = nbOB
// module chunks = 1